<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">
      <q-btn @click="$emit('close')" flat>
        <q-icon name="mdi-arrow-left"> </q-icon>
      </q-btn>
      Checkin {{ raceIndex + 1 }} / {{ round.races.length }}
    </div>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="$store.dispatch('settings/toggleVirtualScrolling')"
      dense
      v-if="$q.screen.gt.xs"
    >
      <q-icon size="xs" name="mdi-printer"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="startScanner"
      dense
    >
      <q-icon size="xs" name="mdi-nfc-variant"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      dense
      @click="checkinAll"
      :loading="checkinAllLoading"
    >
      <q-icon size="xs" name="mdi-check" class="q-mr-sm"></q-icon>
      Mark all
    </q-btn>
    <q-space />
    <!-- <q-input
      style="max-width: 70%"
      filled
      v-model="rfid"
      debounce="200"
      label="Scan RFID"
      clearable
      dense
    >
      <template #prepend>
        <q-icon name="mdi-magnify"> </q-icon>
      </template>
    </q-input> -->
    <!-- <q-btn icon="mdi-close" flat @click="$emit('close')"> </q-btn> -->
    <div
      class="col-12 mt-0 pt-0"
      :style="
        `${
          !disableVirtualScrolling
            ? 'height: calc(100vh - 280px) !important'
            : ''
        }`
      "
    >
      <div
        v-if="disableVirtualScrolling"
        style="width: 100%;
    height: 100%; z-index: 9999999; opacity: 0; background-color: black; position: absolute;"
      ></div>
      <datatable
        :filter="search"
        :flat="true"
        :data="participants"
        :columns="columns"
        :hidePagination="true"
        @rowDoubleClick="handleDoubleClick"
      >
        <template slot="body-cell-id" slot-scope="data">
          <q-td :props="data.props">
            <div class="row items-center">
              <q-checkbox
                v-model="data.props.row.checked_in"
                :true-value="1"
                :false-value="0"
                dense
                @input="
                  updateValue(data.props.row.id, data.props.row.checked_in)
                "
                v-if="data.props.row.scratched != 1"
              ></q-checkbox>
              <q-icon
                v-if="data.props.row.scratched == 1"
                name="mdi-close"
                color="negative"
                size="20px"
              ></q-icon>
              <q-btn dense round flat class="float-right" color="black">
                <q-icon name="mdi-dots-vertical"></q-icon>
                <q-menu>
                  <q-list style="min-width: 100px">
                    <q-item
                      @click="scratch(data.props.row)"
                      clickable
                      v-close-popup
                    >
                      <q-item-section>Scratch/Unscratch</q-item-section>
                    </q-item>
                    <q-separator v-if="data.props.row.team_name" />
                    <q-item
                      clickable
                      @click="
                        currentTeamDetails = data.props.row;
                        teamDetailsModel = true;
                      "
                      v-close-popup
                    >
                      <q-item-section>View Team Details</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>

              <!-- <q-btn
                v-if="data.props.row.team_name"
                round
                flat
                dense
                class="float-right"
                color="black"
              >
                <q-icon name="mdi-dots-vertical"></q-icon>
                <q-menu>
                  <q-list style="min-width: 100px">
                    <q-item
                      clickable
                      @click="
                        currentTeamDetails = data.props.row;
                        teamDetailsModel = true;
                      "
                      v-close-popup
                    >
                      <q-item-section>View Team Details</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn> -->
            </div>
          </q-td>
        </template>
        <template slot="body-cell-capUrl" slot-scope="data">
          <q-td :props="data.props">
            <q-img
              v-if="data.props.row.capUrl"
              :src="data.props.row.capUrl"
              style="width: 40px"
              contain
            >
            </q-img>
            <q-img
              v-else
              src="https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png"
              style="width: 40px"
              contain
            >
            </q-img>
          </q-td>
        </template>
        <template slot="body-cell-firstName" slot-scope="data">
          <q-td
            style="
              min-width: 350px;
              max-width: 350px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
               line-height: 14px
            "
            v-if="!data.props.row.team_name"
            :props="data.props"
            :style="
              `${
                data.props.row.scratched ? 'text-decoration: line-through;' : ''
              };`
            "
          >
            {{ data.props.row.firstName }} {{ data.props.row.lastName }}
            <q-icon
              v-if="data.props.row.rfid"
              color="blue-grey"
              size="xs"
              name="mdi-tag-text"
            >
              <q-tooltip>RFID - {{ data.props.row.rfid }}</q-tooltip>
            </q-icon>
            <br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
          <q-td
            style="
              min-width: 350px;
              max-width: 350px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
               line-height: 14px
            "
            :style="
              `${
                data.props.row.scratched ? 'text-decoration: line-through;' : ''
              };`
            "
            v-else
          >
            <b>{{ data.props.row.team_name }}</b> <br />
            <span
              style="font-size: 10px"
              v-for="(member, index) in data.props.row.members"
              :key="`member_${index}`"
            >
              {{ member.firstName }} {{ member.lastName }}
              {{ index < data.props.row.members.length - 1 ? ", " : "" }}
            </span>
            <br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
        </template>
      </datatable>
    </div>
    <div class="col-12 q-mt-sm" style="margin-top: 9px; z-index: 2">
      <q-btn no-caps color="blue-grey" @click="$emit('close')">Close</q-btn>
      <q-btn
        no-caps
        color="primary"
        :loading="publishLoading"
        @click="publish()"
        class="float-right"
        >Publish</q-btn
      >
    </div>
    <q-dialog v-model="teamDetailsModel">
      <teamDetailsCard :team="currentTeamDetails" />
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";
import teamDetailsCard from "@/components/wavesProgress/teamDetailsCard.vue";

export default {
  components: { datatable, teamDetailsCard },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      event: "events/current",
      disableVirtualScrolling: "settings/disableVirtualScrolling"
    }),
    columns: function() {
      return [
        {
          name: "id",
          label: "",
          align: "left",
          field: "id",
          style:
            "min-width: 90px;max-width: 90px; width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true
        },
        {
          name: "lane_no",
          label: "Ln.",
          align: "left",
          field: "lane_no",
          format: val => val,
          style:
            "min-width: 50px;max-width: 50px;width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "capUrl",
          label: "Club",
          align: "left",
          field: "capUrl",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "firstName",
          label: "Name",
          align: "left",
          field: "firstName",

          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "event_name",
          label: "Event",
          align: "left",
          field: "event_name",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.event.combinedEvents || this.event.combinedEvents.length < 1,
          sortable: true
        }
      ];
    }
  },
  props: {
    round: {
      default: null
    },
    raceIndex: {
      default: 0
    }
  },
  data: () => ({
    rfid: "",

    // Grid

    publishLoading: false,
    teamDetailsModel: false,
    currentTeamDetails: {},
    search: "",

    checkinAllLoading: false,

    participants: []
  }),
  watch: {
    round: function() {
      this.init();
    },
    race: function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.participants = this.round.races[this.raceIndex].lanes.filter(
        l => l.marshalled == 1
      );
    },
    handleDoubleClick() {},
    addMember() {},
    updateValue(id, status) {
      this.$store
        .dispatch("events/updateCheckedInStatus", {
          id: id,
          checked_in: status
        })
        .then(result => {
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },

    publish() {
      this.publishLoading = true;
      this.$store
        .dispatch("events/publishCheckedIn", {
          id: this.round.races[this.raceIndex].id
        })
        .then(result => {
          this.publishLoading = true;
          if (result.Result == "Success") {
            this.round.races[this.raceIndex].checkedIn = 1;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$emit("close");
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    checkinAll() {
      this.checkinLoading = true;
      let notCheckedIn = this.round.races[this.raceIndex].lanes.filter(p => {
        return !p.checked_in;
      });
      this.$store
        .dispatch("events/checkinAll", {
          id: this.round.races[this.raceIndex].id,
          value: notCheckedIn.length > 0 ? 1 : 0
        })
        .then(result => {
          this.markAllLoading = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "eventProgress/loadCurrentRound",
              this.round.id
            );
            this.$store.dispatch(
              "competitions/updateOmega",
              this.$route.params.competitions_id
            );
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    scratch(row) {
      row.scratched = row.scratched == 1 ? 0 : 1;
      row.checked_in = 0;
      this.updateValue(row.id, 0);
      this.$store.dispatch("eventProgress/scratchMember", {
        id: row.participant_id,
        value: row.scratched,
        isTeamEvent: JSON.parse(this.event.playerLabels).length > 1
      });
    },

    // Start Scanner
    async handleNFCScan(message, serialNumber, extraData) {
      // ADD NFC to Member
      try {
        // Find Member Via NFC
        let NFCFound = false;

        // Team
        if (this.participants[0].team_name) {
          this.participants.forEach(team => {
            team.members.forEach(member => {
              member.NFCTags.forEach(tag => {
                if (tag.serialNumber == serialNumber) {
                  team.checked_in = 1;
                  this.updateValue(team.id, 1);
                  NFCFound = true;
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "Member Scanned Successfully"
                  });
                }
              });
            });
          });
        } else {
          // Individual
          this.participants.forEach(member => {
            member.NFCTags.forEach(tag => {
              if (tag.serialNumber == serialNumber) {
                member.checked_in = 1;
                this.updateValue(member.id, 1);
                NFCFound = true;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Member Scanned Successfully"
                });
              }
            });
          });
        }

        if (!NFCFound) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Member Not Found"
          });
        }
      } catch (error) {
        console.log(error);
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    startScanner() {
      this.$store.dispatch("NFC/startScanner", {
        $this: this,
        handleNFCScan: this.handleNFCScan
      });
    }
  }
};
</script>
